export default "__VITE_ASSET__a052e644__"